<template>
	<component :is="testComponent" />
</template>

<script>
export default {
	data () {
		const tests = [
			{
				id: 'psychosocial-risks',
				componentName: 'PsicosocialRisksTest',
				title: this.$i18n.t('tests.psychosocial-risks.title'),
				only360Users: true
			},
			{
				id: 'ryff-scale',
				componentName: 'RyffScaleTest',
				title: this.$i18n.t('tests.ryff-scale.title'),
				alias: 'bienestar-psicologico',
				only360Users: true
			},
			{
				id: 'findrisk',
				componentName: 'FindRiskTest',
				title: this.$i18n.t('tests.findrisk.title')
			},
			{
				id: 'nicotine-dependency',
				componentName: 'NicotineDependencyTest',
				title: this.$i18n.t('tests.nicotine-dependency.title')
			},
			{
				id: 'mediterranean-diet',
				componentName: 'MediterraneanDietTest',
				title: this.$i18n.t('tests.mediterranean-diet.title')
			},
			{
				id: 'stress',
				componentName: 'StressTest',
				title: this.$i18n.t('tests.stress.title'),
				only360Users: true
			},
			{
				id: 'sleep-quality',
				componentName: 'SleepQualityTest',
				title: this.$i18n.t('tests.sleep-quality.title')
			},
			{
				id: 'anxiety-beck',
				componentName: 'AnxietyBeckTest',
				title: this.$i18n.t('tests.anxiety-beck.title')
			},
			{
				id: 'physical-activity',
				componentName: 'PhysicalActivityTest',
				title: this.$i18n.t('tests.physical-activity.title'),
				only360Users: true
			},
			{
				id: 'cardiovascular-risk',
				componentName: 'CardiovascularRiskTest',
				title: this.$i18n.t('tests.cardiovascular-risk.title')
			},
			{
				id: 'general-health',
				componentName: 'GeneralHealthTest',
				title: this.$i18n.t('tests.general-health.title')
			},
			{
				id: 'interpersonal-relationships',
				componentName: 'InterpersonalRelationshipsTest',
				title: this.$i18n.t('tests.interpersonal-relationships.title'),
				only360Users: true
			},
			{
				id: 'social-skills',
				componentName: 'SocialSkillsTest',
				title: this.$i18n.t('tests.social-skills.title')
			},
			{
				id: 'work-environment',
				componentName: 'WorkEnvironmentTest',
				title: this.$i18n.t('tests.work-environment.title'),
				only360Users: true
			}
		]
		return {
			testComponent: null,
			tests: tests
		}
	},
	created () {
		this.loadTest()
	},
	metaInfo () {
		return this.$helpers.buildMetaInfo({ appName: 'opensalud', appTagLine: 'opensalud' })
	},
	methods: {
		loadTest () {
			try {
				let testObj = this.tests.find(test => test.id === this.$route.params.testId || test.alias === this.$route.params.testId)
				if (testObj.only360Users && !this.$store.getters['session/userHasCompanies']) {
					this.$store.commit('setErrorPageMessage', this.$t('errorMessages.only-subscribed-users'))
					this.$router.push(`/error/unauthorized?returnUrl=${this.$route.fullPath}`)
					return
				}
				this.$set(this.$route.meta.title, 'text', testObj.title)
				this.testComponent = () => import(`@/components/views/selfEvaluationTests/${testObj.componentName}`)
			} catch (error) {
				this.$router.push('/error/not-found')
			}
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/TestLoader.vue